const store = {
  state: {
    isPageLoadingUser: false,
    isPageLoadingPrivilege: false
  },

  mutations: {
    SET_IS_PAGE_LOADING_USER: (state, payload) => {
      state.isPageLoadingUser = payload;
    },
    SET_IS_PAGE_LOADING_PRIVILEGE: (state, payload) => {
      state.isPageLoadingPrivilege = payload;
    }
  },

  getters: {
    GetIsPageLoadingUser: state => state.isPageLoadingUser,
    GetIsPageLoadingPrivilege: state => state.isPageLoadingPrivilege
  }
};
export default store;
